document.addEventListener('DOMContentLoaded', function () {
  const description = document.getElementById('product-description-content');
  const toggleBtn = document.getElementById('product-description-read-more');

  if (description && toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      description.classList.toggle('expanded');
      toggleBtn.textContent = description.classList.contains('expanded')
        ? 'Show less'
        : 'View full description';
    });
  }
});

// Delegate click event for dynamically added quick view content
// to edit this code and call shopify event instead
document.addEventListener('click', function (event) {
   // Check if Quick View is open by testing for 'open' class on '.quick-options-drawer'
  const quickViewDrawer = document.querySelector('.quick-options-drawer');
  if (quickViewDrawer && quickViewDrawer.classList.contains('open')) {
    if (event.target.matches('#product-description-read-more')) {
        const toggleBtn = event.target;
        // Since container is sibling before the button:
        const container = toggleBtn.previousElementSibling; 
      
        if (container && container.id === 'product-description-content') {
          container.classList.toggle('expanded');
          toggleBtn.textContent = container.classList.contains('expanded') ? 'Show less' : 'View full description';
          
          toggleBtn.setAttribute('aria-expanded', container.classList.contains('expanded'));
        }
      }
  }
});

// function initCollapsibleDescription(container) {
//   const desc = container.querySelector('#product-description-content');
//   const toggleBtn = container.querySelector('#product-description-read-more');

//   if (desc && toggleBtn) {
//     toggleBtn.addEventListener('click', function () {
//       desc.classList.toggle('expanded');
//       toggleBtn.textContent = desc.classList.contains('expanded') ? 'Show less' : 'View full description';
//       toggleBtn.setAttribute('aria-expanded', desc.classList.contains('expanded'));
//     });
//   }
// }

// // Initialize on page load
// document.addEventListener('DOMContentLoaded', function () {
//   initCollapsibleDescription(document);
// });

// // Re-init after Quick View AJAX loads
// document.addEventListener('shopify:section:load', function (event) {
//   initCollapsibleDescription(event.target);
// });
